// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { FormModal } from 'components/Mantine/Modals/FormModal';
import {
  CreateOrEditTableViewForm,
  type CreateOrEditTableViewFormProps,
} from 'helpers/ag-grid/TableViewPanel/CreateOrEditTableViewForm';
import { isNil } from 'helpers/isNotNil';

type Props = {
  opened: boolean;
  onClose: () => void;
} & CreateOrEditTableViewFormProps;

export const CreateOrEditTableViewModal = ({ opened, onClose, tableView, ...formProps }: Props) => {
  const creating = isNil(tableView);

  return (
    <FormModal
      title={creating ? 'Save current table view' : 'Rename table view'}
      opened={opened}
      onClose={onClose}
      type="submit"
    >
      <CreateOrEditTableViewForm tableView={tableView} {...formProps} />
    </FormModal>
  );
};
